import { Filter } from '@dfl/mui-admin-layout';
import { createdATFilter, getLocationFilterByField } from 'modules/common/constants/filters/common.filters';
import { getVisibleFilter } from 'modules/common/constants/filters';
import { addressFilters } from 'lib/dfl-address-filter';

const visibleFilter = getVisibleFilter('visible');
const distributionZoneFilter = getLocationFilterByField('locations');

// address filters
export const addressFilter = addressFilters({
  countryFilter: 'warehouse:address.country',
  countryKey: 'country',
  countryField: 'country',
  stateFilter: 'warehouse:address.state',
  stateKey: 'state',
  stateField: 'address.state',
  cityFilter: 'warehouse:address.city',
  cityKey: 'city',
  cityField: 'address.state',
  justUseFor: 'CU',
  hideCity: true,
});

export const distributionCentersLogisticProviderFilters: Filter[] = [
  ...addressFilter,
  distributionZoneFilter,
  visibleFilter,
  createdATFilter,
];

export const defaultDistributionCentersLogisticProviderFilters: Filter[] = [...addressFilter, visibleFilter];
